// @ts-check
import { POWER } from './tuning.js';
import { playerBody, collectPower } from './power.js';
import { moveActor } from './actors.js';
/** @typedef {import('./types.js').Level} Level */
/** @typedef {import('./player.js').Position} Player */
/** Purple nodes dispense once. Bits are banked immediately; upgrades emerge into the world.
 * @param {Level} level @param {import('./types.js').Solid} solid @param {Player} state @param {import('./types.js').EventSink} [emit]
 */
export function dispense(level, solid, state, emit) {
  const reward = solid.reward ?? 'bit';
  const kind = reward === 'upgrade' ? state.power === 'base' ? 'core' : 'pulse' : reward;
  const height = kind === 'bit' ? 16 : 22;
  const originY = solid.y + solid.height;
  level.pickups.push({ id: `${solid.id}-reward`, kind, x: solid.x + solid.width / 2 - 11, y: originY - height,
    width: 22, height, vx: kind === 'pulse' || kind === 'bit' ? 0 : POWER.pickupSpeed * state.facing, vy: 0, age: 0, originY });
  if (kind === 'bit') level.bits++;
  emit?.({ type: 'reward-spawned', x: solid.x + solid.width / 2, y: originY, reward: kind, entityId: solid.id });
}
/** @param {Level} level @param {Player} state @param {number} dt @param {import('./types.js').EventSink} [emit] */
export function updateRewards(level, state, dt, emit) {
  level.pickups = level.pickups.filter((item) => {
    item.age += dt;
    if (item.kind === 'bit') { item.y = item.originY + Math.sin(Math.min(1, item.age / 0.65) * Math.PI) * 40; return item.age < 0.65; }
    if (item.age < POWER.emergeTime) { item.y = item.originY - item.height * (1 - item.age / POWER.emergeTime); return true; }
    if (item.age - dt < POWER.emergeTime) item.y = item.originY;
    if (moveActor(item, level, dt) && item.kind === 'overclock') item.vy = 340;
    const body = playerBody(state);
    if (state.x + body.width > item.x && state.x < item.x + item.width && state.y + body.height > item.y && state.y < item.y + item.height) {
      collectPower(level, state, item.kind, event => emit?.({ ...event, entityId: item.id })); return false;
    }
    return item.y > -120 && item.age < 30;
  });
}
